module.exports = __webpack_public_path__ + "fonts/FilsonPro-Bold.3a2dc40.ttf";